import React from 'react'

function Bb() {
  return (
    <div>Mob</div>
  )
}

export default Bb